import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { updateMyProfile } from '../../../api/profileService';

export default function ProfileInfoForm({ successCallback = null, profile = null, mode = "edit", open, onClose }) {

    const { t } = useTranslation('common'); 

    const [professionalName, setProfessionalName] = React.useState(profile?.professional_name ? profile.professional_name  : "");
    const [licenseNumber, setLicenseNumber] = React.useState(profile?.license_number ? profile.license_number : "");
    const [ptrNumber, setPtrNumber] = React.useState(profile?.ptr_number ? profile.ptr_number : "");
    const [s2LicenseNumber, setS2LicenseNumber] = React.useState(profile?.s2_license_number ? profile.s2_license_number : "");

    const { showSnackbar } = useSnackbar();

    const onUpdateSuccess = () => {
      successCallback();
    };

    React.useEffect(() => {
      // reset field when there are changes (e.g. when opening edit)
      setProfessionalName(profile?.professional_name ? profile.professional_name  : "");
      setLicenseNumber(profile?.license_number ? profile.license_number : "");
      setPtrNumber(profile?.ptr_number ? profile.ptr_number : "");
      setS2LicenseNumber(profile?.s2_license_number ? profile.s2_license_number : "");
    }, [profile, open]);

    const handleSave = async () => {
        try 
        {
          if (mode === "edit" && profile) {
              await updateMyProfile({ 
                  professional_name: professionalName,
                  license_number: licenseNumber,
                  ptr_number: ptrNumber,
                  s2_license_number: s2LicenseNumber
              });
              onUpdateSuccess();
              showSnackbar(t('profile.messages.update_success'), "success");
          }
          setProfessionalName("");
          setLicenseNumber("");
          setPtrNumber("");
          setS2LicenseNumber("");
          onClose();     // close dialog
        } catch (err) {
          showSnackbar(t('profile.messages.update_fail'), "error");
        }

    };

    const handleCancel = () => {
        setProfessionalName("");
        setLicenseNumber("");
        setPtrNumber("");
        setS2LicenseNumber("");
      onClose();
    };

    return (
        <>
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>

        <DialogTitle>Edit Profile Information</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}>
            <TextField
                label="Professional Name"
                variant="outlined"
                value={professionalName}
                onChange={(e) => setProfessionalName(e.target.value)}
                fullWidth
            />
            <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Please include your title(s) and designation(s)</Typography>
            <br />
            <TextField
                label="License Number"
                variant="outlined"
                value={licenseNumber}
                onChange={(e) => setLicenseNumber(e.target.value)}
                fullWidth
            />
            <TextField
                label="PTR Number"
                variant="outlined"
                value={ptrNumber}
                onChange={(e) => setPtrNumber(e.target.value)}
                fullWidth
            />
            <TextField
                label="S2 License Number"
                variant="outlined"
                value={s2LicenseNumber}
                onChange={(e) => setS2LicenseNumber(e.target.value)}
                fullWidth
            />
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSave}>
              Save
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
        </>
    );
}